import { PRO_PAGES } from '../containers/ProPages/constants';
import { FESTIVAL_TAB_VALUES, PRO_TAB_VALUES } from './consts';

export const route = {
  ACCOUNT_SETTINGS: '/account-settings',
  ACCOUNT_SUBSCRIPTIONS: '/account-subscription',
  ARTICLES: '/articles',
  ARTISTS: '/artists',
  CASTING_TOOL: '/casting',
  COMPANIES: '/companies',
  COMPETITIONS: '/competitions',
  COMPOSERS: '/composers',
  CONTACT_OB: '/contact',
  COOKIE_POLICY: '/cookpol',
  DYNAMIC_ID_ROUTE: rootRoute => `${rootRoute}/[id]`,
  DYNAMIC_ID_ROUTE_WITH_ACTION: rootRoute => `${rootRoute}/[id]/[[...action]]`,
  FESTIVALS: '/festivals',
  HIGHLIGHTS: '/highlights',
  HOME: '/',
  VIDEOS: '/videos',

  INTRO: '/pro/[type]',
  INTRO_AGENTS: `/pro/${PRO_PAGES.AGENCIES}`,
  INTRO_AOS: `/pro/${PRO_PAGES.COMPANIES}`,
  INTRO_ARTISTS: `/pro/${PRO_PAGES.ARTISTS}`,
  INTRO_AUDIENCE: '/proaudience',
  INTRO_ACADEMIA: `/pro/${PRO_TAB_VALUES.ACADEMIA}`,
  INTRO_JOURNALISTS: `/pro/${PRO_TAB_VALUES.JOURNALIST}`,

  DETAILS: `/pro/[type]/details`,
  DETAILS_AGENTS: `/pro/${PRO_PAGES.AGENCIES}/details`,
  DETAILS_AOS: `/pro/${PRO_PAGES.COMPANIES}/details`,
  DETAILS_ARTISTS: `/pro/${PRO_PAGES.ARTISTS}/details`,

  INTRO_ARCHIVES: '/',
  INTRO_OB: '/intro',
  JOURNALISTS_AND_RESEARCH: '/journalist-and-research', // TODO change on real
  LIBRARY: '/library',
  LOGIN: '/login',
  MANAGERS: '/managers',
  MAPS: '/maps',
  NEW_RARE: '/new-and-rare',
  ON_THESE_DAY: '/onthisday',
  PAYMENT: '/payment',
  REACTIVATE: '/payment/reactivate',
  PRIVACY: '/privpol',
  PRODUCTIONS: '/productions',
  REGISTER: '/register',
  RENTALS: '/rentals',
  RESET_PASSWORD: '/login/reset',
  SEASONS: '/seasons',
  SECURITY: '/security',
  STATISTICS: '/statistics',
  STATS_NUMBERS: '/stats/numbers',
  TERMS_AND_CONDITIOS: '/termpol',
  VENUES: '/venues',
  WORK_WITH_OB: '/',
  WORKS: '/works',
  PAYMENT_TERMS: '/payment-terms',
  NOTIFICATIONS: '/notifications',
  LINK: '/link',
  SELECT_PROFILE: '/select-profile',
};

export const actionsPagesRoutes = {
  ADD_ARTIST_TO_ROSTER: 'agency_artist_add',
  ADD_AGREEMENTS: 'agency_single_artist_updt',
  EDIT_AGENCY: 'agency_modif',
};

export const companiesPaths = {
  country: `${route.COMPANIES}/[country]`,
  company: `${route.COMPANIES}/[country]/[id]/[[...action]]`,
  edit: `${route.COMPANIES}/[country]/[id]/edit`,
  revivals: `${route.COMPANIES}/[country]/[id]/edit/revivals`,
  searchProductions: `${route.COMPANIES}/[country]/[id]/edit/search-productions`,
  addProduction: `${route.COMPANIES}/[country]/[id]/edit/modify-production`,
};

export const agencyPaths = {
  agency: `${route.MANAGERS}/[id]`,
};

export const festivalPaths = {
  view: `${route.FESTIVALS}/[country]/[id]`,
  edit: `${route.FESTIVALS}/[country]/[id]/edit`,
  modifyProduction: `${route.FESTIVALS}/[country]/[id]/edit/modify-production`,
  contact: `${route.FESTIVALS}/[country]/[id]/${FESTIVAL_TAB_VALUES.CONTACT}`,
  venues: `${route.FESTIVALS}/[country]/[id]/${FESTIVAL_TAB_VALUES.VENUES}`,
  about: `${route.FESTIVALS}/[country]/[id]/${FESTIVAL_TAB_VALUES.ABOUT}`,
  performances: `${route.FESTIVALS}/[country]/[id]/${FESTIVAL_TAB_VALUES.PERFORMANCES}`,
  videos: `${route.FESTIVALS}/[country]/[id]/${FESTIVAL_TAB_VALUES.VIDEOS}`,
  images: `${route.FESTIVALS}/[country]/[id]/${FESTIVAL_TAB_VALUES.IMAGES}`,
  reviews: `${route.FESTIVALS}/[country]/[id]/${FESTIVAL_TAB_VALUES.REVIEWS}`,
  revivals: `${route.FESTIVALS}/[country]/[id]/edit/revivals`,
  searchProductions: `${route.FESTIVALS}/[country]/[id]/edit/search-productions`,
  festival: `${route.FESTIVALS}/[festival]/[id]/[[...action]]`,
};

export const artistsPaths = {
  id: `${route.ARTISTS}/[id]`,
  edit: `${route.ARTISTS}/[id]/edit`,
  modifyProduction: `${route.ARTISTS}/[id]/edit/modify-production`,
  searchProductions: `${route.ARTISTS}/[id]/edit/search-productions`,
  photos: `${route.ARTISTS}/[id]/photos`,
  videos: `${route.ARTISTS}/[id]/videos`,
  repertoire: `${route.ARTISTS}/[id]/repertoire`,
  reviews: `${route.ARTISTS}/[id]/reviews`,
  bio: `${route.ARTISTS}/[id]/bio`,
  revivals: `${route.ARTISTS}/[id]/edit/revivals`,
};

export const venuePaths = {
  venue: `${route.VENUES}/[country]/[id]/[[...action]]`,
};

export const videosPaths = {
  videos: `${route.VIDEOS}/`,
  videosSearch: `${route.VIDEOS}/search`,
};

export default route;
